export const LIST_PROFILE_CONFIGURATION_REQUEST = 'LIST_PROFILE_CONFIGURATION_REQUEST'
export const LIST_PROFILE_CONFIGURATION_SUCCESS = 'LIST_PROFILE_CONFIGURATION_SUCCESS'
export const LIST_PROFILE_CONFIGURATION_FAIL = 'LIST_PROFILE_CONFIGURATION_FAIL'

export const LIST_USER_INTERNAL_PROFILE_CONFIGURATION_REQUEST = 'LIST_USER_INTERNAL_PROFILE_CONFIGURATION_REQUEST'
export const LIST_USER_INTERNAL_PROFILE_CONFIGURATION_SUCCESS = 'LIST_USER_INTERNAL_PROFILE_CONFIGURATION_SUCCESS'
export const LIST_USER_INTERNAL_PROFILE_CONFIGURATION_FAIL = 'LIST_USER_INTERNAL_PROFILE_CONFIGURATION_FAIL'

export const PROFILE_CONFIGURATION_ACTIVE_REQUEST = 'PROFILE_CONFIGURATION_ACTIVE_REQUEST'
export const PROFILE_CONFIGURATION_ACTIVE_SUCCESS = 'PROFILE_CONFIGURATION_ACTIVE_SUCCESS'
export const PROFILE_CONFIGURATION_ACTIVE_FAIL = 'PROFILE_CONFIGURATION_ACTIVE_FAIL'

export const SET_PROFILE_CONFIGURATION_ACTIVE_REQUEST = 'SET_PROFILE_CONFIGURATION_ACTIVE_REQUEST'
export const SET_PROFILE_CONFIGURATION_ACTIVE_SUCCESS = 'SET_PROFILE_CONFIGURATION_ACTIVE_SUCCESS'
export const SET_PROFILE_CONFIGURATION_ACTIVE_FAIL = 'SET_PROFILE_CONFIGURATION_ACTIVE_FAIL'

export const CREATE_PROFILE_CONFIGURATION_REQUEST = 'CREATE_PROFILE_CONFIGURATION_REQUEST'
export const CREATE_PROFILE_CONFIGURATION_SUCCESS = 'CREATE_PROFILE_CONFIGURATION_SUCCESS'
export const CREATE_PROFILE_CONFIGURATION_FAIL = 'CREATE_PROFILE_CONFIGURATION_FAIL'

export const DETAIL_PROFILE_CONFIGURATION_REQUEST = 'DETAIL_PROFILE_CONFIGURATION_REQUEST'
export const DETAIL_PROFILE_CONFIGURATION_SUCCESS = 'DETAIL_PROFILE_CONFIGURATION_SUCCESS'
export const DETAIL_PROFILE_CONFIGURATION_FAIL = 'DETAIL_PROFILE_CONFIGURATION_FAIL'

export const UPDATE_PROFILE_CONFIGURATION_REQUEST = 'UPDATE_PROFILE_CONFIGURATION_REQUEST'
export const UPDATE_PROFILE_CONFIGURATION_SUCCESS = 'UPDATE_PROFILE_CONFIGURATION_SUCCESS'
export const UPDATE_PROFILE_CONFIGURATION_FAIL = 'UPDATE_PROFILE_CONFIGURATION_FAIL'

export const DELETE_PROFILE_CONFIGURATION_REQUEST = 'DELETE_PROFILE_CONFIGURATION_REQUEST'
export const DELETE_PROFILE_CONFIGURATION_SUCCESS = 'DELETE_PROFILE_CONFIGURATION_SUCCESS'
export const DELETE_PROFILE_CONFIGURATION_FAIL = 'DELETE_PROFILE_CONFIGURATION_FAIL'